<template>
  <el-cascader
    :ref="refName"
    :options="options"
    :props="props"
    placeholder="请选择或请输入快速找到选项"
    clearable
    filterable
    separator
    @visible-change="elCascaderOnlick"
    @expand-change="elCascaderOnlick"
    @change="handleGeo"
  />
</template>
<script>
export default {
  name: 'Cascader',
  props: {
    refName: {},
    options: {},
    props: {}
  },
  methods: {
    handleGeo(value) {
      this.$refs[this.refName].dropDownVisible = false
      this.$emit('update:code', value.join(':'))
      this.$emit('callback')
    },
    elCascaderOnlick() {
      const that = this
      setTimeout(function() {
        document.querySelectorAll('.el-cascader-node__label').forEach((el) => {
          el.onclick = function() {
            that.previousElementSibling && that.previousElementSibling.click()
          }
        })
      }, 100)
    }
  }
}
</script>
<style lang="scss">
  .el-cascader-panel .el-radio {
		// display: none;
	}
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #1da373;
    background: #1da373;
  }
  .el-radio__inner:hover {
    border-color: #1da373;
  }
</style>
